var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9237 18.3337L9.80834 17.6926L12.3724 13.2055H16.2186C16.5586 13.2055 16.8847 13.0704 17.1251 12.8299C17.3656 12.5895 17.5007 12.2634 17.5007 11.9234V4.23109C17.5007 3.89107 17.3656 3.56498 17.1251 3.32455C16.8847 3.08412 16.5586 2.94904 16.2186 2.94904H3.39809C3.05807 2.94904 2.73197 3.08412 2.49154 3.32455C2.25111 3.56498 2.11604 3.89107 2.11604 4.23109V11.9234C2.11604 12.2634 2.25111 12.5895 2.49154 12.8299C2.73197 13.0704 3.05807 13.2055 3.39809 13.2055H9.16732V14.4875H3.39809C2.71804 14.4875 2.06586 14.2174 1.58499 13.7365C1.10413 13.2556 0.833984 12.6034 0.833984 11.9234V4.23109C0.833984 3.55105 1.10413 2.89886 1.58499 2.418C2.06586 1.93714 2.71804 1.66699 3.39809 1.66699H16.2186C16.8986 1.66699 17.5508 1.93714 18.0317 2.418C18.5126 2.89886 18.7827 3.55105 18.7827 4.23109V11.9234C18.7827 12.6034 18.5126 13.2556 18.0317 13.7365C17.5508 14.2174 16.8986 14.4875 16.2186 14.4875H13.116L10.9237 18.3337ZM14.9365 5.51315H4.68014V6.7952H14.9365V5.51315ZM4.68014 9.3593H11.0904V10.6414H4.68014V9.3593Z",
    fill: "#E9EEF7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.6a180e8d94361693dda45123cb381760.svg";
export { ForwardRef as ReactComponent };